import vars from './variables';

type SectionTitleBorderProps = {
  colour: string;
}

type GetTilePropsProps = {
  tileTypeProp: string;
}

export const sectionTitleBorder: (colour?: string) => string = (colour = vars.coreDarkGrey) => {
  /* Creates vertical highlight line inline with sidebar */
  return `
    position: relative;
    padding: 0;
    margin-left: 0;
    z-index: 200;
  `;
};

export const getTileProps: (tileType: string) => any = (tileType) => {
  if (tileType === 'tactical') {
    return vars.tacticalTileProps;
  } else if (tileType === 'listing') {
    return vars.listingTileProps;
  } else if (tileType === 'double') {
    return vars.doubleTileProps;
  } else if (tileType === 'homepageStandard') {
    return vars.homepageStandardTileProps;
  } else if (tileType === 'homepageDouble') {
    return vars.homepageDoubleTileProps;
  } else {
    return vars.standardTileProps;
  }
};

export const getTileImageParameters: (tileType: string) => string = (tileType) => {
  const tileProps = getTileProps(tileType);

  return `fm=${vars.defaultImageFormat}&w=${tileProps.imageWidthPixel * 2}&h=${
    tileProps.imageHeightPixel * 2
  }&fit=${vars.defaultImageFit}&q=${vars.defaultImageQuality}&f=${
    vars.defaultImageFocus
  }`;
};

export const getImageParameters: (
  src: string,
  format?: string,
  width?: number,
  height?: number,
  fit?: string,
  focus?: string,
  quality?: number
) => string = (
  src,
  format = vars.defaultImageFormat,
  width,
  height,
  fit = vars.defaultImageFit,
  focus = vars.defaultImageFocus,
  quality = vars.defaultImageQuality
) => {
  /* List of valid parameters:
  www.contentful.com/developers/docs/references/images-api
  */

  if (format.toString().slice(-4) === 'jpeg') {
    format = 'jpg';
  } else if (format.toString().slice(-4) === 'webp') {
    format = 'webp';
    quality = 80;
  } else if (format.toString().slice(-3) === 'gif') {
    format = 'gif';
  } else if (format.toString().slice(-3) === 'png') {
    format = 'png';
  } else {
    format = vars.defaultImageFormat;
  }

  let widthString = width ? `&w=${width}` : ``;
  let heightString = height ? `&h=${height}` : ``;

  return `${src}?fm=${format}&fit=${fit}&q=${quality}&f=${focus}${widthString}${heightString}`;
};